import { jsxs as S, jsx as s } from "react/jsx-runtime";
import { useRef as T, useCallback as E, useEffect as C, forwardRef as L } from "react";
import { H as M } from "../index-Dlw4JYvo.js";
import { c as W } from "../clsx-OuTLNxxd.js";
import { B as q } from "../Button-C2yT_E3v.js";
import '../Dialog.css';const P = "_closeButton_1qjom_32", X = "_dialog_1qjom_36", Y = "_hasBackdrop_1qjom_50", $ = "_isFullScreen_1qjom_53", z = "_closeButtonWrapper_1qjom_62", H = "_dialogWrapper_1qjom_75", A = "_panel_1qjom_89", a = {
  closeButton: P,
  dialog: X,
  hasBackdrop: Y,
  isFullScreen: $,
  closeButtonWrapper: z,
  dialogWrapper: H,
  panel: A
}, x = ({
  children: t,
  className: r,
  hasBackdrop: n = !0,
  isFullScreen: N = !1,
  isOpen: e = !1,
  setIsOpen: i,
  shouldCloseOnClickOutside: u = !0,
  title: p,
  triggerRef: l,
  ...b
}) => {
  const c = T(null), d = E(
    (o) => {
      var k, g, j;
      if (!u)
        return;
      const w = (k = c.current) == null ? void 0 : k.getBoundingClientRect(), { bottom: m = 0, left: _ = 0, right: f = 0, top: B = 0 } = w || {};
      if (B === 0 && m === 0 && _ === 0 && f === 0)
        return;
      const y = o.clientY < B || o.clientY > m || o.clientX < _ || o.clientX > f, h = ((g = l == null ? void 0 : l.current) == null ? void 0 : g.isConnected) ?? !1, D = h && ((j = l == null ? void 0 : l.current) == null ? void 0 : j.contains(o == null ? void 0 : o.target)), F = o.target === c.current;
      e && (F || y && !D && h) && i(!1);
    },
    [e, u, i, l]
  );
  return C(() => {
    c.current && (e ? c.current.showModal() : c.current.close());
  }, [c, e]), C(() => {
    if (!(typeof window > "u"))
      return document.addEventListener("click", d), () => {
        document.removeEventListener("click", d);
      };
  }, [d]), /* @__PURE__ */ S(
    "dialog",
    {
      "aria-label": `${p}-modal`,
      className: W(
        a.dialog,
        { [a.hasBackdrop]: n },
        { [a.isFullScreen]: N },
        r
      ),
      "data-cxy-name": "dialog",
      id: "cxy-dialog",
      ref: c,
      ...b,
      children: [
        /* @__PURE__ */ s("div", { className: a.closeButtonWrapper, children: /* @__PURE__ */ s(
          q,
          {
            "aria-label": `Close ${p} Modal`,
            className: a.closeButton,
            "data-testid": "close-button",
            onClick: () => i(!1),
            variant: "ghost",
            children: /* @__PURE__ */ s(M, { size: "xl" })
          }
        ) }),
        /* @__PURE__ */ s("div", { className: a.dialogWrapper, children: t })
      ]
    }
  );
}, G = ({ children: t, className: r, ...n }) => /* @__PURE__ */ s("section", { className: W(a.panel, r), ...n, children: /* @__PURE__ */ s("div", { className: a.panelWrapper, children: t }) }), J = L(({ children: t, ...r }, n) => /* @__PURE__ */ s(q, { ref: n, variant: "ghost", ...r, children: t }));
x.Panel = G;
x.Trigger = J;
export {
  x as Dialog
};
